import { Button, Modal } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import InputField from "components/Input/InputField";
import WholeScreenLoader from "components/WholeScreenLoader";
import axios from "const/axios";
import { API_URL, states } from "const/constants";
import useKothar from "context/useKothar";
import { useEffect, useState } from "react";
import { AiOutlineDelete, AiOutlineEye } from "react-icons/ai";
import { IoArrowBack } from "react-icons/io5";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FaUniversity,
  FaMoneyBillWave,
  FaGraduationCap,
  FaLanguage,
  FaBookOpen,
  FaClipboardList,
  FaCalculator,
  FaCalendarAlt,
  FaClipboardCheck,
  FaGift,
  FaUserGraduate,
  FaLayerGroup,
  FaGlobe,
} from "react-icons/fa";

const AddCourse = ({ color = "light" }) => {
  const [data, setData] = useState({
    name: null,
    abn: null,
    contactPerson: null,
    email: null,
    country: "Australia",
    state: [],
    zipCode: null,
    image: null,
    courses: [
      {
        college: "",
        courseName: "",
        durationInWeeks: "",
        noOfSem: "",
        feePerSem: "",
        totalFees: "",
        intakes: [],
        maxScholarship: "",
        feesBreakdown: [{ uuid: crypto.randomUUID(), maximum: "", average: "", minimum: "" }],
        scholarships: [{ uuid: crypto.randomUUID(), intake: "", scholarship: "", note: "" }],
      },
    ],
  });

  const [feesModalOpen, setFeesModalOpen] = useState(false);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [scholarshipModalOpen, setScholarshipModalOpen] = useState(false);
  const [selectedScholarshipCourse, setSelectedScholarshipCourse] = useState(null);

  const navigate = useNavigate();
  const [{}, { refetchUniData }] = useKothar();

  const { state } = useLocation();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData((prevState) => ({ ...prevState, [name]: value }));
  };

  const { id } = useParams();

  const getCourseData = async () => {
    if (id !== null) {
      const response = await axios.get(`/courses/with-offerings/${id}`);

      setData({
        ...response?.data?.data,
      });
    }
    return data;
  };

  useEffect(() => {
    if (id) {
      getCourseData();
    }
  }, [id]);

  console.log(data);

  const { mutate, isLoading } = useMutation(postData, {
    onSuccess(res) {
      toast.success(data?.id ? "Data updated Successfully" : "Data added Successfully");
      refetchUniData();
      // setTimeout(() => {
      navigate("/admin/university");
      // }, 2000);
    },
    onError() {
      toast.error(data?.id ? "Error Updating Data" : "Error Submitting Data");
    },
  });

  async function postData(payload) {
    if (data?.id) {
      await axios.put(`${API_URL}/university/${payload?.id}`, payload);
    } else {
      await axios.post(`${API_URL}/university`, payload);
    }
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    mutate({
      ...data,
      state: data?.state?.map((item) => item?.value).join("/"),
    });
  };

  const openFeesModal = (index) => {
    setSelectedCourse(data.offerings[index]);
    setFeesModalOpen(true);
  };

  const closeFeesModal = () => {
    setFeesModalOpen(false);
    setSelectedCourse(null);
  };

  const addNewFeesBreakdown = () => {
    setSelectedCourse((prev) => ({
      ...prev,
      feesBreakdown: [
        ...(prev.feesBreakdown || []),
        { uuid: crypto.randomUUID(), maximum: "", average: "", minimum: "" },
      ],
    }));
  };

  const removeFeesBreakdown = (index) => {
    setSelectedCourse((prev) => ({
      ...prev,
      feesBreakdown: prev.feesBreakdown.filter((_, i) => i !== index),
    }));
  };

  const handleFeesBreakdownChange = (index, field, value) => {
    setSelectedCourse((prev) => ({
      ...prev,
      feesBreakdown: prev.feesBreakdown.map((fee, i) =>
        i === index ? { ...fee, [field]: value } : fee
      ),
    }));
  };

  const saveFeesBreakdown = () => {
    setData((prev) => ({
      ...prev,
      courses: prev.courses.map((course) => (course === selectedCourse ? selectedCourse : course)),
    }));
    closeFeesModal();
  };

  const openScholarshipModal = (index) => {
    setSelectedScholarshipCourse(data.offerings[index]);
    setScholarshipModalOpen(true);
  };

  const closeScholarshipModal = () => {
    setScholarshipModalOpen(false);
    setSelectedScholarshipCourse(null);
  };

  const addNewScholarship = () => {
    setSelectedScholarshipCourse((prev) => ({
      ...prev,
      scholarships: [
        ...(prev.scholarships || []),
        { uuid: crypto.randomUUID(), intake: "", scholarship: "", note: "" },
      ],
    }));
  };

  const removeScholarship = (index) => {
    setSelectedScholarshipCourse((prev) => ({
      ...prev,
      scholarships: prev.scholarships.filter((_, i) => i !== index),
    }));
  };

  const handleScholarshipChange = (index, field, value) => {
    setSelectedScholarshipCourse((prev) => ({
      ...prev,
      scholarships: prev.scholarships.map((scholarship, i) =>
        i === index ? { ...scholarship, [field]: value } : scholarship
      ),
    }));
  };

  const saveScholarship = () => {
    setData((prev) => ({
      ...prev,
      courses: prev.courses.map((course) =>
        course === selectedScholarshipCourse ? selectedScholarshipCourse : course
      ),
    }));
    closeScholarshipModal();
  };

  const toggleEditMode = (index) => {};

  const handleSaveRow = (index) => {
    // Here you can add any validation or save logic if needed
    toggleEditMode(index);
  };

  const handleCancelEdit = (index) => {
    // Reset the row data to its original state
    setData((prev) => ({
      ...prev,
      courses: prev.courses.map((course, i) => (i === index ? { ...course } : course)),
    }));
    toggleEditMode(index);
  };

  return (
    <div className="flex flex-wrap mt-4 dashBody">
      <div className="w-full mb-12 px-4">
        <div
          className={
            "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
            "bg-app-surface text-app-text"
          }
        >
          <div className="rounded-t mb-0 px-10 py-3 border-0">
            <div className="flex flex-wrap items-center">
              <div className="relative w-full max-w-full flex justify-start gap-4 items-center">
                <IoArrowBack className="text-xl cursor-pointer" onClick={() => navigate(-1)} />
                <h3 className={"font-semibold text-xl text-app-text"}>Course Details</h3>
              </div>
            </div>
          </div>

          <div className="block w-full overflow-x-auto mt-2">
            <div className="flex-auto lg:px-10 py-10 pt-0">
              <form className="space-y-4 md:space-y-6" onSubmit={handleSubmit}>
                <div className="mt-2">
                  <CourseOfferingsOverview
                    courseName={data.courseName}
                    alternativeName={data.alternativeName}
                    offerings={data.offerings}
                  />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Fees Breakdown Modal */}
      <Modal open={feesModalOpen} onClose={closeFeesModal}>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-app-surface p-6 rounded-lg shadow-xl w-[600px]">
          <h3 className="text-lg font-semibold mb-4">Total Fees Breakdown</h3>

          <table className="w-full border">
            <thead>
              <tr>
                <th className="px-4 py-2 border">S.N.</th>
                <th className="px-4 py-2 border">Maximum</th>
                <th className="px-4 py-2 border">Average</th>
                <th className="px-4 py-2 border">Minimum</th>
                <th className="px-4 py-2 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {selectedCourse?.feesBreakdown?.map((fee, idx) => (
                <tr key={idx}>
                  <td className="px-4 py-2 border">{idx + 1}</td>
                  <td className="px-4 py-2 border">
                    <InputField
                      type="number"
                      value={fee.maximum}
                      onChange={(e) => handleFeesBreakdownChange(idx, "maximum", e.target.value)}
                      disabled
                    />
                  </td>
                  <td className="px-4 py-2 border">
                    <InputField
                      type="number"
                      value={fee.average}
                      onChange={(e) => handleFeesBreakdownChange(idx, "average", e.target.value)}
                      disabled
                    />
                  </td>
                  <td className="px-4 py-2 border">
                    <InputField
                      type="number"
                      value={fee.minimum}
                      onChange={(e) => handleFeesBreakdownChange(idx, "minimum", e.target.value)}
                      disabled
                    />
                  </td>
                  <td className="px-4 py-2 border">
                    <button
                      type="button"
                      onClick={() => removeFeesBreakdown(idx)}
                      className="text-red-600 hover:text-red-800"
                      disabled={true}
                    >
                      <AiOutlineDelete />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* <Button
            variant="outlined"
            onClick={addNewFeesBreakdown}
            className="mt-4"
          >
            Add Row
          </Button> */}

          <div className="flex justify-end gap-4 mt-6">
            <Button variant="outlined" onClick={closeFeesModal}>
              Cancel
            </Button>
            <Button variant="contained" onClick={saveFeesBreakdown}>
              Save
            </Button>
          </div>
        </div>
      </Modal>

      {/* Scholarship Modal */}
      <Modal open={scholarshipModalOpen} onClose={closeScholarshipModal}>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-app-surface p-6 rounded-lg shadow-xl w-[600px]">
          <h3 className="text-lg font-semibold mb-4">Scholarship Details</h3>

          <table className="w-full border">
            <thead>
              <tr>
                <th className="px-4 py-2 border">Intake</th>
                <th className="px-4 py-2 border">Scholarship</th>
                <th className="px-4 py-2 border">Note</th>
                <th className="px-4 py-2 border">Actions</th>
              </tr>
            </thead>
            <tbody>
              {selectedScholarshipCourse?.scholarships?.map((scholarship, idx) => (
                <tr key={idx}>
                  <td className="px-4 py-2 border">
                    <span>{scholarship?.intake}</span>
                  </td>
                  <td className="px-4 py-2 border">
                    <InputField
                      type="number"
                      value={scholarship.scholarship}
                      onChange={(e) => handleScholarshipChange(idx, "scholarship", e.target.value)}
                      disabled
                    />
                  </td>
                  <td className="px-4 py-2 border">
                    <InputField
                      type="text"
                      value={scholarship.note}
                      onChange={(e) => handleScholarshipChange(idx, "note", e.target.value)}
                      disabled
                    />
                  </td>
                  <td className="px-4 py-2 border">
                    <button
                      type="button"
                      onClick={() => removeScholarship(idx)}
                      className="text-red-600 hover:text-red-800"
                      disabled={true}
                    >
                      <AiOutlineDelete />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-end gap-4 mt-6">
            <Button variant="outlined" onClick={closeScholarshipModal}>
              Cancel
            </Button>
            <Button variant="contained" onClick={saveScholarship}>
              Save
            </Button>
          </div>
        </div>
      </Modal>

      {isLoading && <WholeScreenLoader open={isLoading} />}
    </div>
  );
};

const CourseOfferingsOverview = ({ courseName, offerings }) => (
  <div className="p-6">
    <h2 className="text-2xl font-semibold mb-2">{courseName}</h2>

    <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-6">
      {offerings?.map((off, idx) => (
        <UniversityOfferingCard offering={off} key={idx} />
      ))}
    </div>
  </div>
);

const UniversityOfferingCard = ({ offering, key }) => (
  <div
    className="bg-app-surface rounded-xl shadow-lg p-6 flex flex-col gap-4 w-full  mx-auto"
    key={key}
  >
    {/* University Name */}
    <div className="flex items-center gap-2 mb-2">
      <FaUniversity className="text-primary text-xl" />
      <span className="font-semibold text-xl uppercase">{offering?.universityName}</span>
    </div>
    {/* Main Info Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 text-sm mt-2">
      {/* Fee Per Semester */}
      <div className="flex items-center gap-3 bg-blue-50 rounded p-3 shadow-sm">
        <FaMoneyBillWave className="text-blue-500 text-lg" />
        <div>
          <div className="font-semibold text-primary">Fee/Sem</div>
          <div className="text-lg font-bold text-blue-900">${offering?.feePerSem || "-"}</div>
        </div>
      </div>{" "}
      {/* Semesters */}
      <div className="flex items-center gap-3 bg-yellow-50 rounded p-3 shadow-sm">
        <FaLayerGroup className="text-yellow-500 text-lg" />
        <div>
          <div className="font-semibold text-yellow-700">Semesters</div>
          <div className="text-lg font-bold text-yellow-900">{offering?.noOfSem || "-"}</div>
        </div>
      </div>
      {/* Total Fees */}
      <div className="flex items-center gap-3 bg-green-50 rounded p-3 shadow-sm">
        <FaCalculator className="text-green-500 text-lg" />
        <div>
          <div className="font-semibold text-green-700">Total Fees</div>
          <div className="text-lg font-bold text-green-900">${offering?.totalFees || "-"}</div>
        </div>
      </div>
      {/* Material Fee */}
      <div className="flex items-center gap-3 bg-purple-50 rounded p-3 shadow-sm">
        <FaClipboardCheck className="text-purple-500 text-lg" />
        <div>
          <div className="font-semibold text-purple-700">Material Fee</div>
          <div className="text-lg font-bold text-purple-900">{offering?.materialFee || "-"}</div>
        </div>
      </div>
      {/* Enrollment Fee */}
      <div className="flex items-center gap-3 bg-pink-50 rounded p-3 shadow-sm">
        <FaUserGraduate className="text-pink-500 text-lg" />
        <div>
          <div className="font-semibold text-pink-700">Enrollment Fee</div>
          <div className="text-lg font-bold text-pink-900">{offering?.enrollmentFee || "-"}</div>
        </div>
      </div>
      {/* Max Scholarship */}
      <div className="flex items-center gap-3 bg-orange-50 rounded p-3 shadow-sm">
        <FaGift className="text-orange-500 text-lg" />
        <div>
          <div className="font-semibold text-orange-700">Max Scholarship</div>
          <div className="text-lg font-bold text-orange-900">{offering?.maxScholarship || "-"}</div>
        </div>
      </div>
      {/* Intakes */}
      <div className="flex items-center gap-3 bg-cyan-50 rounded p-3 shadow-sm col-span-1 sm:col-span-2 md:col-span-3">
        <FaCalendarAlt className="text-cyan-500 text-lg" />
        <div>
          <div className="font-semibold text-cyan-700">Intakes Available</div>
          <div className="text-lg font-bold text-cyan-900">
            {offering?.intakes?.join(", ") || "-"}
          </div>
        </div>
      </div>
    </div>
    {/* Fees Breakdown */}
    {/* <div>
      <span className="font-semibold">Fees Breakdown:</span>
      <table className="w-full text-xs mt-1 border">
        <thead>
          <tr>
            <th className="border px-2">Max</th>
            <th className="border px-2">Avg</th>
            <th className="border px-2">Min</th>
          </tr>
        </thead>
        <tbody>
          {offering.feesBreakdown?.map((fee) => (
            <tr key={fee.uuid}>
              <td className="border px-2">{fee.maximum || "-"}</td>
              <td className="border px-2">{fee.average || "-"}</td>
              <td className="border px-2">{fee.minimum || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div> */}
    {/* Scholarships */}
    {/* <div>
      <span className="font-semibold">Scholarships:</span>
      <table className="w-full text-xs mt-1 border">
        <thead>
          <tr>
            <th className="border px-2">Intake</th>
            <th className="border px-2">Amount</th>
            <th className="border px-2">Note</th>
          </tr>
        </thead>
        <tbody>
          {offering.scholarships?.map((sch) => (
            <tr key={sch.uuid}>
              <td className="border px-2">{sch.intake || "-"}</td>
              <td className="border px-2">{sch.scholarship || "-"}</td>
              <td className="border px-2">{sch.note || "-"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div> */}
    {/* State-wise/Onshore Fees */}
    {offering.onshoreFees && offering.onshoreFees.length > 0 && (
      <div className="mt-4">
        <div className="flex items-center gap-2 mb-2">
          <FaUserGraduate className="text-blue-500 text-lg" />
          <span className="font-semibold text-primary text-base">State-wise (Onshore) Fees</span>
        </div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-xs border rounded-lg shadow-sm bg-blue-50">
            <thead>
              <tr className="bg-blue-100">
                <th className="border px-3 py-2 font-semibold">State</th>
                <th className="border px-3 py-2 font-semibold">Fee/Sem</th>
                <th className="border px-3 py-2 font-semibold">Total Fees</th>
                <th className="border px-3 py-2 font-semibold">Scholarship</th>
                <th className="border px-3 py-2 font-semibold">Fee After Scholarship</th>
                <th className="border px-3 py-2 font-semibold">Discount (%)</th>
              </tr>
            </thead>
            <tbody>
              {offering?.onshoreFees?.map((fee) => (
                <tr key={fee.uuid} className="hover:bg-blue-200 transition">
                  <td className="border px-3 py-2">{fee.state || "-"}</td>
                  <td className="border px-3 py-2 font-bold text-blue-900">
                    {fee.feePerSem || "-"}
                  </td>
                  <td className="border px-3 py-2">{fee.totalFees || "-"}</td>
                  <td className="border px-3 py-2 text-green-700 font-semibold">
                    {fee.scholarship || "-"}
                  </td>
                  <td className="border px-3 py-2">{fee.feeAfterScholarship || "-"}</td>
                  <td className="border px-3 py-2">{fee.discount || "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    )}
    {/* Offshore Fees */}

    {/* {offering?.offshoreFees && ( */}
    <div className="mt-4">
      <div className="flex items-center gap-2 mb-2">
        <FaGlobe className="text-cyan-500 text-lg" />
        <span className="font-semibold text-cyan-700 text-base">Offshore Fees</span>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-full text-xs border rounded-lg shadow-sm bg-cyan-50">
          <thead>
            <tr className="bg-cyan-100">
              <th className="border px-3 py-2 font-semibold">Fee/Sem</th>
              <th className="border px-3 py-2 font-semibold">Total Fees</th>
              <th className="border px-3 py-2 font-semibold">Scholarship</th>
              <th className="border px-3 py-2 font-semibold">Fee After Scholarship</th>
              <th className="border px-3 py-2 font-semibold">Discount (%)</th>
              <th className="border px-3 py-2 font-semibold">State</th>
              <th className="border px-3 py-2 font-semibold">Key1</th>
            </tr>
          </thead>
          <tbody>
            <tr className="hover:bg-cyan-200 transition">
              <td className="border px-3 py-2 font-bold text-cyan-900">
                {offering?.offshoreFees?.feePerSem || "-"}
              </td>
              <td className="border px-3 py-2">{offering?.offshoreFees?.totalFees || "-"}</td>
              <td className="border px-3 py-2 text-green-700 font-semibold">
                {offering?.offshoreFees?.scholarship || "-"}
              </td>
              <td className="border px-3 py-2">
                {offering?.offshoreFees?.feeAfterScholarship || "-"}
              </td>
              <td className="border px-3 py-2">{offering?.offshoreFees?.discount || "-"}</td>
              <td className="border px-3 py-2">{offering?.offshoreFees?.state || "-"}</td>
              <td className="border px-3 py-2">{offering?.offshoreFees?.key1 || "-"}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    {/* )} */}

    {/* Requirements */}
    <div className="grid grid-cols-1 md:grid-cols-1 gap-4 text-xs mt-4">
      {/* English Requirements */}
      <div className="flex items-start gap-3 bg-blue-50 border-l-4 border-blue-400 rounded p-3">
        <FaLanguage className="text-blue-500 text-lg mt-1" />
        <div>
          <div className="font-semibold text-primary mb-1">English Requirements</div>
          <div className="text-app-text">
            {offering.englishLanguageRequirements || (
              <span className="italic text-app-text-muted">Not specified</span>
            )}
          </div>
        </div>
      </div>
      {/* Academic Requirements */}
      <div className="flex items-start gap-3 bg-green-50 border-l-4 border-green-400 rounded p-3">
        <FaBookOpen className="text-green-500 text-lg mt-1" />
        <div>
          <div className="font-semibold text-green-700 mb-1">Academic Requirements</div>
          <div className="text-app-text">
            {offering.academicRequirements || (
              <span className="italic text-app-text-muted">Not specified</span>
            )}
          </div>
        </div>
      </div>
      {/* Other Requirements */}
      <div className="flex items-start gap-3 bg-yellow-50 border-l-4 border-yellow-400 rounded p-3">
        <FaClipboardList className="text-yellow-500 text-lg mt-1" />
        <div>
          <div className="font-semibold text-yellow-700 mb-1">Other Requirements</div>
          <div className="text-app-text">
            {offering.otherRequirements || (
              <span className="italic text-app-text-muted">Not specified</span>
            )}
          </div>
        </div>
      </div>
    </div>

    {/* Website Link */}
    {offering.websiteLink && (
      <div className="mt-2">
        <a
          href={offering.websiteLink}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-500 underline"
        >
          University Website
        </a>
      </div>
    )}
  </div>
);

export default AddCourse;
